export default __webpack_public_path__ + "static/media/camilla-schjoelin-poulsen-navn.5be19132.png";